import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Job_event_bs$SolvuuApi0 from "./job_event_bs.bs.js";
var write_status = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x >= 479410653) {
    if (x >= 785140586) {
      if (x >= 951752159) {
        return Atdgen_codec_runtime.Encode.constr0("Running");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Unknown");
      }
    } else if (x >= 486291009) {
      return Atdgen_codec_runtime.Encode.constr0("Succeeded");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Failed");
    }
  } else if (x >= -113393609) {
    return Atdgen_codec_runtime.Encode.constr0("Pending");
  } else {
    return Atdgen_codec_runtime.Encode.constr0("Canceled");
  }
});
var read_status = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Pending",
/* `Single */
[-306849112,
/* Pending */
-113393609]],
/* :: */
[
/* tuple */
["Running",
/* `Single */
[-306849112,
/* Running */
951752159]],
/* :: */
[
/* tuple */
["Succeeded",
/* `Single */
[-306849112,
/* Succeeded */
486291009]],
/* :: */
[
/* tuple */
["Failed",
/* `Single */
[-306849112,
/* Failed */
479410653]],
/* :: */
[
/* tuple */
["Canceled",
/* `Single */
[-306849112,
/* Canceled */
-120073095]],
/* :: */
[
/* tuple */
["Unknown",
/* `Single */
[-306849112,
/* Unknown */
785140586]],
/* [] */
0]]]]]]);

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(Id_bs$SolvuuApi0.write_blob, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(Id_bs$SolvuuApi0.read_blob, param);
}

var write_output = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "prefix", t.prefix),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "blobs", t.blobs),
  /* [] */
  0]]);
});
var read_output = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    prefix: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("prefix", Atdgen_codec_runtime.Decode.string, param);
    }, json),
    blobs: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("blobs", read__1, param);
    }, json)
  };
});
var write_backend = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr0("Not_implemented");
});
var read_backend = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Not_implemented",
/* `Single */
[-306849112,
/* Not_implemented */
-498198474]],
/* [] */
0]);

function write__3(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Atdgen_codec_runtime.Encode.$$float, param);
}

var read__3 = Atdgen_codec_runtime.Decode.option_as_constr(Atdgen_codec_runtime.Decode.$$float);

function write__2(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(write_backend, param);
}

var read__2 = Atdgen_codec_runtime.Decode.option_as_constr(read_backend);
var write_t = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_job, "id", t.id),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Job_event_bs$SolvuuApi0.write_create, "spec", t.spec),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "backend", t.backend),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_status, "status", t.status),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "input", t.input),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_output, "output", t.output),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$float, "created", t.created),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__3, "completed", t.completed),
  /* [] */
  0]]]]]]]]);
});
var read_t = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_job, param);
    }, json),
    spec: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("spec", Job_event_bs$SolvuuApi0.read_create, param);
    }, json),
    backend: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("backend", read__2, param);
    }, json),
    status: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("status", read_status, param);
    }, json),
    input: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("input", read__1, param);
    }, json),
    output: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("output", read_output, param);
    }, json),
    created: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("created", Atdgen_codec_runtime.Decode.$$float, param);
    }, json),
    completed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("completed", read__3, param);
    }, json)
  };
});
var read_spec = Job_event_bs$SolvuuApi0.read_create;
var write_spec = Job_event_bs$SolvuuApi0.write_create;
var read_blob_id = Id_bs$SolvuuApi0.read_blob;
var write_blob_id = Id_bs$SolvuuApi0.write_blob;
var read_job_id = Id_bs$SolvuuApi0.read_job;
var write_job_id = Id_bs$SolvuuApi0.write_job;
export { read_status, write_status, read_spec, write_spec, read_blob_id, write_blob_id, read_output, write_output, read_job_id, write_job_id, read_backend, write_backend, read_t, write_t };
/* write_status Not a pure module */